module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/base-module/components/text-area/text-area.component.scss
// module id = ./src/app/modules/base-module/components/text-area/text-area.component.scss
// module chunks = 9